import React from 'react'
import styled from '@emotion/styled'
import { BlockBDCNavy as BDCLogo } from '../svgs/BlockBDCNavy'
import { BlockBDCWhite as BDCWhite } from '../svgs/BlockBDCWhite'
import { Link } from '@jelly/ui'

const HOMEPAGE = '/'

const BdcLogoWrapper = styled(Link)`
	display: inline-block;
	height: 57px;
	width: 165px;

	${({ theme }) => theme.MQ.S} {
		height: 70px;
		width: 200px;
	}
`
export function HeaderLogoBdc({ variant = 'default' }) {
	return (
		<BdcLogoWrapper href={HOMEPAGE} aria-label="business.com Logo">
			{variant === 'white' ? <BDCWhite /> : <BDCLogo />}
		</BdcLogoWrapper>
	)
}
